import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { MONTHLY_REPORT_TITLE_ACTIONS_ID } from '../constants';

/**
 * Page title for the layout header. The header renders outside the table, so the table fills
 * the empty slot with its selection-dependent "Bulk Approve (n)" action through a portal.
 */
export const MonthlyReportTitle = () => (
  <span className="flex items-center gap-4">
    {/* CrumbTitle resolves via t(), which falls back to the key instead of throwing like <Translation> does. */}
    <CrumbTitle id="paymentManagement.affiliatePaymentLogs.monthlyReport.page.title" />
    <span id={MONTHLY_REPORT_TITLE_ACTIONS_ID} className="flex items-center" />
  </span>
);
